import { render } from "./PolicyView.vue.ts?vue&type=template&id=e2126cef&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PolicyView.vue?vue&type=template&id=e2126cef&ts=true"
import script from "./PolicyView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PolicyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PolicyView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/views/steps/PolicyView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2126cef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2126cef', __exports__)) {
    api.reload('e2126cef', __exports__)
  }
  
  module.hot.accept("./PolicyView.vue.ts?vue&type=template&id=e2126cef&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PolicyView.vue?vue&type=template&id=e2126cef&ts=true", () => {
    api.rerender('e2126cef', render)
  })

}


export default __exports__